import { matchesWeeklyTimeInterval } from "app/shared/utils/weekly-time-interval";

export interface CourtPricingRule {
  timeBand?: string;
  label: string;
  daysOfWeek: number[];
  startTime?: string;
  endTime?: string;
  pricePerHour: number;
}

function rateAt(court: any, date: Date): number {
  const minute = date.getHours() * 60 + date.getMinutes();
  const weekday = date.getDay();
  const rule = (court?.pricingRules || []).find((item: CourtPricingRule) => {
    return matchesWeeklyTimeInterval(item, weekday, minute);
  });
  return Number(rule?.pricePerHour ?? court?.pricePerHour ?? 0);
}

export function previewCourtPrice(
  court: any,
  start: Date,
  durationMinutes: number,
): {
  pricePerHour: number;
  total: number;
} {
  if (!court || !Number.isFinite(durationMinutes) || durationMinutes <= 0) {
    return { pricePerHour: 0, total: 0 };
  }
  let total = 0;
  for (let offset = 0; offset < durationMinutes; offset += 1) {
    total += rateAt(court, new Date(start.getTime() + offset * 60_000)) / 60;
  }
  const roundedTotal = Math.round((total + Number.EPSILON) * 100) / 100;
  return {
    pricePerHour:
      Math.round(((roundedTotal * 60) / durationMinutes) * 100) / 100,
    total: roundedTotal,
  };
}
